import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

import { AppCard } from '../general';
import { ChartSeries } from '../../models/chart/chart';
import { useEffect, useState } from 'react';

const defaultOptions: ApexOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '50%',
    },
    boxPlot: {
      colors: {
        upper: '#e9ecef',
        lower: '#f8f9fa',
      },
    },
  },
  stroke: {
    colors: ['#6c757d'],
  },
};

const BoxAndWhiskerChartWidget = (props: {
  className?: string;
  title: string;
  chartHeight?: string;
  chartSeries: ChartSeries[] | undefined;
}): JSX.Element => {
  const { className, title, chartHeight, chartSeries } = props;

  const [series, setSeries] = useState<ApexAxisChartSeries | undefined>([]);

  useEffect(() => {
    setSeries(chartSeries ?? []);
  }, [chartSeries]);

  return (
    <AppCard className={className} title={title}>
      <Chart height={chartHeight ?? '275px'} options={defaultOptions} series={series} type="boxPlot" />
    </AppCard>
  );
};

export default BoxAndWhiskerChartWidget;
